import { getSplitMainButtonStyle } from './deviceMenuStyles';

export const micBarsWrapStyle = {
  height: 12,
  display: 'flex',
  alignItems: 'flex-end',
  gap: 3,
  marginRight: 8,
};

export const micBarBaseStyle = {
  width: 3,
  borderRadius: 999,
  background: 'rgba(126, 222, 246, 0.35)',
  transition: 'opacity 90ms linear, background 90ms linear',
};

export const MIC_BAR_LEVELS = [
  { threshold: 10, height: 4 },
  { threshold: 20, height: 6 },
  { threshold: 32, height: 9 },
  { threshold: 46, height: 12 },
];

export const micMainContentStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
};

export const getMainButtonStyle = ({ off, hovered, includeMicTester }) => ({
  ...getSplitMainButtonStyle({
    off,
    hovered,
    width: includeMicTester ? 88 : 44,
    minWidth: includeMicTester ? 88 : 44,
  }),
});

export const buildMicBars = ({ muted, micLevel }) => MIC_BAR_LEVELS.map((bar) => {
  const active = !muted && micLevel >= bar.threshold;
  return {
    ...micBarBaseStyle,
    height: bar.height,
    opacity: active ? 1 : 0.35,
    background: active ? '#8fe6fb' : micBarBaseStyle.background,
  };
});
